import { render } from "./CustomHeader.vue?vue&type=template&id=7bb5ffa6&scoped=true&ts=true"
import script from "./CustomHeader.vue?vue&type=script&lang=ts"
export * from "./CustomHeader.vue?vue&type=script&lang=ts"

import "./CustomHeader.vue?vue&type=style&index=0&id=7bb5ffa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb5ffa6"]])

export default __exports__